import OptionLinks from '../../../../store/bookable-objects/option-links';

angular
    .module('festzelt-os.modules.bo')
    .factory('BoOptionsLinks', [
        '$injector',
        'BoOptionLink',
        ($injector, BoOptionLink) => new OptionLinks(BoOptionLink, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/bo/option-links/store/option-links.js